import { makeAutoObservable } from 'mobx';
import { IValidatedInputLibrary } from '../IValidatedInputLibrary';
import * as DateFNS from "date-fns";

export class DateInputLibrary implements IValidatedInputLibrary
{
	constructor(isRequired: () => boolean, minDate?:Date, maxDate?:Date)
	{
		this.IsRequired = isRequired;
		makeAutoObservable(this, {}, { autoBind: true });
		this.MinDate = minDate;
		this.MaxDate = maxDate;
	}

	/** Содержимое поля ввода */
	public Value: Date | null = null;
	public setValue(value: Date | null) { this.Value = value; }

	/** Валидность поля ввода */
	public IsValid: boolean = true;
	public setIsValid(value: boolean) { this.IsValid = value; }

	/** Форматирование в ISO */
	public toISO(): string
	{
		return this.Value === null ? "" : DateFNS.formatISO(this.Value);
	}

	/** Необходимость поля ввода */
	public IsRequired: () =>boolean;

	/** Доступность поля ввода */
	public IsDisabled: boolean = false;
	public setIsDisabled(value: boolean) { this.IsDisabled = value; }

	/** Минимальная разрешенная дата */
	public MinDate: Date | undefined = undefined;
	public setMinDate(value: Date) { this.MinDate = value; }

	/** Максимальная разрешенная дата */
	public MaxDate: Date | undefined = undefined;
	public setMaxDate(value: Date) { this.MaxDate = value; }

	/** Валидация */
	public Validate(onlyCheck?: boolean): boolean
	{
		if (this.IsDisabled)
		{
			if (onlyCheck) return true;
			this.IsValid = true;
			return this.IsValid;
		}

		if (this.Value === null)
		{
			if (this.IsRequired())
			{
				if (onlyCheck) return false;
				this.IsValid = false;
				return this.IsValid;
			}

			if (onlyCheck) return true;
			this.IsValid = true;
			return this.IsValid;
		}
		if (!DateFNS.isValid(this.Value))
		{
			if (onlyCheck) return false;
			this.IsValid = false;
			return this.IsValid;
		}

		if (this.MaxDate && (DateFNS.compareAsc(this.Value, this.MaxDate) === 1))
		{
			if (onlyCheck) return false;
			this.IsValid = false;
			return this.IsValid;
		}

		if (this.MinDate && (DateFNS.compareAsc(this.Value, this.MinDate) === -1))
		{
			if (onlyCheck) return false;
			this.IsValid = false;
			return this.IsValid;
		}

		if (onlyCheck) return true;
		this.IsValid = true;
		return this.IsValid;
	}

}
